import React from 'react';
import { formatDate } from '../../../../../helpers/date/formatDate';

export const RecapClasse = ({ classe }) => {
  return (
    <p>
      Vous allez accompagner la classe {classe.classeName} pour ce challenge qui
      va se dérouler du {formatDate(classe.debut)} au {formatDate(classe.fin)} .
    </p>
  );
};
